import StartScreenSearch from './StartScreenSearch';

export default StartScreenSearch;



// WEBPACK FOOTER //
// ./src/components/organisms/StartScreenSearch/index.js